@if (auth.authenticated() && !auth.isBambergDisplayUser()) {
  <app-navbar></app-navbar>
} @else {
  <router-outlet></router-outlet>
}
